// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2YKwX","rootSuccess":"CompleteLink_rootSuccess__22kUw","rootFailure":"CompleteLink_rootFailure__3osUM","isDisabled":"CompleteLink_isDisabled__3mLUe"};